import { useEffect, useState } from 'react'
import FactuurRij, { GEDAAN } from '../onderdelen/FactuurRij'
import { FoutVak, Kop, Laden, Leeg, Ververs } from '../onderdelen/ui'
import { api, Fout } from '../lib/api'
import { datumKort } from '../lib/opmaak'
import type { Expense } from '../lib/types'

/* ===========================================================================
 *  Geschiedenis: de facturen waar jij het laatst iets mee deed
 *
 *  Uit dezelfde historie als de Tijdlijn (expense_gebeurtenis, door = jij),
 *  per factuur de laatste keer. Handig voor "die van gisteren, waar was die
 *  ook alweer".
 * =========================================================================== */

export default function Geschiedenis() {
  const [bonnen, setBonnen] = useState<Expense[] | null>(null)
  const [laden, setLaden] = useState(false)
  const [fout, setFout] = useState<string | null>(null)

  async function haal() {
    setLaden(true)
    setFout(null)
    try { setBonnen(await api.geschiedenis()) } catch (e) { setFout(e instanceof Fout ? e.message : String(e)) } finally { setLaden(false) }
  }
  useEffect(() => { void haal() }, [])

  return (
    <div className="scherm">
      <Kop terugNaar="/" terugLabel="Dashboard" titel="Geschiedenis" rechts={<Ververs bezig={laden} opKlik={() => void haal()} />} />
      {fout && <FoutVak tekst={fout} opnieuw={() => void haal()} />}
      {!bonnen && laden && <Laden />}
      {bonnen && bonnen.length === 0 && <Leeg>Je hebt nog niets met een factuur gedaan.</Leeg>}
      <ul className="lijst">
        {(bonnen ?? []).map((b) => (
          <FactuurRij key={b.id} bon={b} lijst={bonnen ?? []}
            extra={`${GEDAAN[b.gedaan ?? ''] ?? 'Gedaan'} op ${datumKort(b.gedaanAt)}`} />
        ))}
      </ul>
    </div>
  )
}
